var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"back-btn",attrs:{"to":_vm.to}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icons.back}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }